import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import css from '../usage.scss';

export const UsageBlock = ({ info, title, variant }) => (
    <div className={css[variant]}>
        <div className={css.info}>{info}</div>
        <div className={css.title}>{title}</div>
    </div>
);

UsageBlock.propTypes = {
    info: PropTypes.oneOfType(PropTypes.string, PropTypes.number),
    title: PropTypes.string.isRequired,
    variant: PropTypes.oneOf('block', 'goldBar')
};

UsageBlock.defaultProps = {
    isGoldBarBlock: false,
    variant: 'block'
};

export default styleable(css)(UsageBlock);



// WEBPACK FOOTER //
// ./components/usage/components/usage-block.js